import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCoins = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.15 14.3c0 1.346-2.115 2.437-4.722 2.437s-4.721-1.091-4.721-2.437M8.573 12.137c-2.607 0-4.721-1.091-4.721-2.438"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.852 5.438v8.524c0 1.347 2.114 2.438 4.721 2.438"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.573 7.874c-2.607 0-4.721-1.09-4.721-2.437C3.852 4.092 5.966 3 8.573 3s4.722 1.092 4.722 2.437M20.15 10.038v8.525c0 1.347-2.115 2.437-4.722 2.437s-4.721-1.09-4.721-2.437v-8.525"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.15 10.038c0 1.345-2.115 2.437-4.722 2.437s-4.721-1.092-4.721-2.437c0-1.346 2.113-2.437 4.72-2.437 2.608 0 4.723 1.091 4.723 2.437"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCoins);
export default ForwardRef;
